import { Component, OnInit } from '@angular/core';
import { Archive } from './Archive';
import * as $ from 'jquery';

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.scss']
})
export class ArchiveComponent implements OnInit {
archive:Archive;
  constructor(private http: HttpClient , private route: ActivatedRoute) { }

  ngOnInit() {
    $(window).scrollTop(0);
    this.http.get<Archive>('http://servers.itresources.am/p_n/public/api/archive').subscribe(data => {
      this.archive = data;
    });
  }

}
